import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import gql from 'graphql-tag';
import { ModalDirective } from 'ng-uikit-pro-standard/lib/free/modals/modal.directive';
import { TipoMensaje } from 'src/Wheel.Styles.HighVolume/Mensaje';
import { NotificacionGenerica } from 'src/Wheel.Styles.HighVolume/Notificacion';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { UsuarioService } from 'src/app/services/usuario.service';
import { sucursal } from 'src/app/shared/object/sucursal.model';
import { usuario } from 'src/app/shared/object/usuario.model';
import { usuario_rol } from 'src/app/shared/object/usuario_rol.model';
import { GraphQLClient } from 'src/app/shared/services/graph-qlclient.service';
import { RutService } from 'src/app/shared/services/rut.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ValidadoresService } from 'src/app/shared/validadores/validadores';
import { rol } from './../../../../shared/object/roles.model';
import { sucursal_usuario } from './../../../../shared/object/sucursal_usuario.model';
import { sucursal_usuarioJoin } from './../../../../shared/object/sucursal_usuarioJoin.model';

@Component({
  selector: 'app-usuarios-vendedor',
  templateUrl: './usuarios-vendedor.component.html',
  styleUrls: ['./usuarios-vendedor.component.scss'],
  providers: [SecurityService, ValidadoresService]

})
export class UsuariosVendedorComponent implements OnInit {
  private client: GraphQLClient = null;
  usuarioList: usuario[];
  selectedUsuario: usuario;
  selectedUsuarioRol: usuario_rol;
  usuario: usuario;
  usuario_rol: usuario_rol;
  formulario: FormGroup;
  optionsRol: Array<any> = [];
  optionsUsuarioRol: Array<any> = [];
  optionsSucursal: Array<any> = [];
  rolList: rol[];
  sucursalList: sucursal[];
  usuarioSucursalList: sucursal_usuarioJoin[];
  selectedSucursalUsuario: sucursal_usuario;
  public rut_empresa;
  sucursalCodigo: any;
  UsuarioObject: any = {};
  public roles_codigo: Array<any> = [];
  public sucursal_codigo: Array<any> = [];
  public options;
  public nombre:string;
  public rut:0;
  public rut_usuario =  Number(this.accesolocalstorage.getRutUsuario());
  public codgo_modulo:number = 20;

  @ViewChild('agregarUsuario', { static: true }) agregarModal: ModalDirective;

  @Output() onSave: EventEmitter<any> = new EventEmitter<any>()
  @Output() onSuccess: EventEmitter<any> = new EventEmitter<any>()



  constructor(client: GraphQLClient,
    private formBuilder: FormBuilder,
    private accesolocalstorage: SecurityService,
    private rutService: RutService,
    private usuarioService: UsuarioService,
    private messageRendererService: MessageRendererService,
    public validadores: ValidadoresService) {
      this.client = client;
      this.buildForm();

     }

     buildForm() {
      this.formulario = this.formBuilder.group({
        rut_usuario: ['', [Validators.minLength(7), Validators.maxLength(13), Validators.required, this.validadores.ValidaFormatoRut]],
        login: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(20)]],
        password: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(15)]],
        confirmarpass: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(15)]],
        mail: ['', [Validators.required, Validators.email]],
        activo: true,
        nombre_completo: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(100)]],
        flag_cambioclave:[''],
        rol: ['', [Validators.required]],
        sucursal: ['']
      });
      this.formulario.valueChanges.subscribe(field => {
        if (field.password !== field.confirmarpass) {
          this.formulario.controls["confirmarpass"].setErrors({ mismatch: true });
        } else {
          this.formulario.controls["confirmarpass"].setErrors(null);
        }
      });
    }


  ngOnInit() {
    this.selectedUsuario = {
      rut_usuario: null,
      login: '',
      password: '',
      fecha_creacion: new Date(),
      fecha_modificacion: new Date(),
      mail: '',
      activo: true,
      nombre_completo: '',
      flag_cambioclave: true,
      max_conexiones_concurrentes: 1
    };

    this.selectedUsuarioRol = {
      rut_usuario: null,
      roles_codigo: null,
      fecha_asignacion: new Date(),
    };

    this.selectedSucursalUsuario = {
      rut_empresa: null,
      sucursal_codigo:null,
      fecha_asignacion: new Date(),
      rut_usuario:null
    };
    this.rut_empresa = this.accesolocalstorage.getRutEmpresa();
    this.sucursalCodigo = this.accesolocalstorage.getSucursalCodigo();

    this.obtenerSucursalxEmpresa(this.rut_empresa);
    this.obtenerDatosUsuario();
    this.obtenerRoles();
  }

  obtenerSucursalxEmpresa(rut_empresa: number) {
    rut_empresa;
    let self = this;
    this.client.query({
      query: gql`
      query($rut_empresa:Decimal){
        sucursal{
          obtenerSucursalxEmpresa(rut_empresa:$rut_empresa){
            respuesta{
              registros{
                rut_empresa
                codigo
                nombre
                descripcion
                activo
                fecha_creacion
              }
            }
          }
        }
      }
      `,
      variables: {
        'rut_empresa': rut_empresa,
      },
      fetchPolicy: 'network-only',
    }, function (respuesta) {
      self.sucursalList = respuesta.data.sucursal.obtenerSucursalxEmpresa.respuesta.registros;
      self.optionsSucursal = [];
      var sel: any;
      self.sucursalList.forEach(element => {
        if (element.activo == true) {
          sel = { value: element.codigo, label: element.nombre };
          self.optionsSucursal.push(sel);
        }
      });
    });
  }

  obtenerSegunFiltroUsuarioxEmpresa(filtro_nombre:string, filtro_rut:number) {
    console.log('que tiene ngModel ', this.options);

    let rut_empresa = this.accesolocalstorage.getRutEmpresa();
    let self = this;
    self.selectedUsuario = {
      rut_usuario: null,
      login: '',
      password: '',
      fecha_creacion: new Date(),
      fecha_modificacion: new Date(),
      mail: '',
      activo: true,
      nombre_completo: '',
      flag_cambioclave: true,
      max_conexiones_concurrentes: 1
    };
    var bodyx = self.selectedUsuario;
    if (filtro_nombre != undefined){
      bodyx.nombre_completo = filtro_nombre;
    }
    if (filtro_rut != undefined && filtro_rut != Number('')){
      bodyx.rut_usuario = this.rutService.QuitarDV(
        this.rutService.Limpiar(filtro_rut));
    }
    this.client.mutate({
      mutation: gql`
      query ($rut_empresa:Decimal, $roles_codigo:[Decimal], $sucursal_codigo:[Decimal], $entidad:usuarioInputType){
        usuario{
          obtenerSegunFiltroUsuarioxEmpresa(rut_empresa:$rut_empresa,roles_codigo:$roles_codigo,
            sucursal_codigo:$sucursal_codigo,filtro:{
            exacto:$entidad
          })
          {
            respuesta
            {
              registros
              {
                rut_usuario
                login
                fecha_creacion
                fecha_modificacion
                mail
                activo
                nombre_completo
                flag_cambioclave
                max_conexiones_concurrentes
              }
            }
          }
        }
      }
      `,
      variables: {
        'entidad': bodyx,
        'rut_empresa':rut_empresa,
        'roles_codigo':self.roles_codigo,
        'sucursal_codigo':self.sucursal_codigo
      }
    },
      function (respuesta) {
        self.usuarioList = respuesta.data.usuario.obtenerSegunFiltroUsuarioxEmpresa.respuesta.registros;
        self.datosUsuarios(self.usuarioList);
      });
      //console.log(self.roles_codigo);
  }

  datosUsuarios(usuario){
    console.log(usuario);

    // const inputParams = {
    //   entidad:{
    //     rut_usuario: Number(filtro_rut),
    //     login: '',
    //     password: '',
    //     fecha_creacion: new Date(),
    //     fecha_modificacion: new Date(),
    //     mail: '',
    //     activo: true,
    //     nombre_completo: filtro_nombre,
    //     flag_cambioclave: true
    //   },
    //   rut_empresa: this.rut_empresa,
    //   roles_codigo: roles,
    //   sucursal_codigo: this.sucursalCodigo
    // }

    // OBTENER USUARIO
    // this.usuarioService.obtenerUsuariosxEmpresa(inputParams, ({ mensajes, respuesta }) => {

    // })

    // EMAIL

    // ROL

  }

  obtenerRoles() {
    let self = this;
    this.client.query({
      query: gql`
        query {
          rol
          {
            obtenerTodos {
              respuesta {
                registros {
                  codigo
                  nombre
                  descripcion
                  activado
                  fecha_creacion
                }
              }
            }
          }
        }
        `
      ,
      fetchPolicy: 'network-only',
    }, function (respuesta) {
      self.rolList = respuesta.data.rol.obtenerTodos.respuesta.registros;
      self.optionsRol = [];
      var sel: any;

      self.rolList.forEach(element => {
        if (element.activado == true) {
          sel = { value: element.codigo, label: element.nombre };
          self.optionsRol.push(sel);
        }
      });
    });
  }

  showModalAgregar() {
    this.usuarioSucursalList = [];
    const self = this;
    let codigo_operacion = 3
    this.client.query({
      query: gql`
      query ($rut_usu:Decimal, $codgo_modulo:Decimal, $cod_operacion:Decimal)
      {
        rol_operacion
        {
          operacionPermitida(rut_usu:$rut_usu, codgo_modulo: $codgo_modulo, cod_operacion:$cod_operacion)
          {
            mensajes
            {
              texto
              tipo
            }
            respuesta
          }
        }
      }
        `,
      variables: {
        'rut_usu': self.rut_usuario,
        'codgo_modulo': self.codgo_modulo,
        'cod_operacion': codigo_operacion,
      },
      fetchPolicy: 'no-cache',
    }, function (respuesta) {
      const notificacion: NotificacionGenerica<string> = NotificacionGenerica.parse(respuesta.data.rol_operacion.operacionPermitida);
      if (notificacion.mensajes[0].tipo == TipoMensaje.SUCCESS) {
        self.agregarModal.show();
      }
      else {
        alert(notificacion.mensajes[0].texto);
      }
    });
  }

  load(nombre, rut){
    this.formulario.get('nombre_completo').setValue(nombre);
    this.formulario.get('rut_usuario').setValue(rut);
    const codigo_rol = this.rolList.find(x=>x.activado === true && x.nombre === 'Vendedores').codigo
    this.formulario.get('rol').setValue(codigo_rol);
    this.obtenerUsuario(rut);

   this.showModalAgregar();
  }

  obtenerUsuario(rut){
    const rutFormato = this.rutService.QuitarDV(
      this.rutService.Limpiar(rut.toString()));

      const inputParams = {
        entidad:{
          rut_usuario: rutFormato,
          login: '',
          password: '',
          fecha_creacion: new Date(),
          fecha_modificacion: new Date(),
          mail: '',
          activo: true,
          nombre_completo: null,
          flag_cambioclave: true
        },
        rut_empresa: this.rut_empresa,
        roles_codigo: [],
        sucursal_codigo: []
      };

      this.usuarioService.obtenerUsuariosxEmpresa(inputParams, ({ mensajes, respuesta }) => {
        const ok = respuesta !== null
        if (!ok) {
          this.messageRendererService.showErrors(mensajes)
          return
        }
        const {registros} = respuesta;
        //completar informacion de usuario
        this.UsuarioObject = {
          login:  registros[0].login,
          mail: registros[0].mail
        }

      });
  }

  mascaraRut(evento) {
    this.validadores._mascaraRut(evento);
  }



  agregarSucursal(){
    var sel: any;
    var arr= [];
    let sucursal_codigo = this.formulario.controls["sucursal"].value;
    let rut_empresa = 0;
    let nombre = "";
    let fecha_asignacion = new Date();
    let rut_usuario = Number(this.validadores._desenmascaraRutyQuitaDV(this.formulario.controls["rut_usuario"].value));
    if (sucursal_codigo == null) {
      return;
    }
    this.sucursalList.forEach(element=>{
      if(element.codigo == sucursal_codigo){
        nombre = element.nombre;
      }
    });

    for (let item of this.usuarioSucursalList){
      arr = [item["sucursal_codigo"], item["nombre"]];
      var idx = arr.indexOf(sucursal_codigo);
      if(idx != -1){
        return;
      }
    }
    sel= {rut_empresa, sucursal_codigo, nombre, fecha_asignacion, rut_usuario};
    this.usuarioSucursalList.push(sel);
  }

  eliminarSucursal(index){
    this.usuarioSucursalList.splice(index, 1);
  }

  ValidaQueExisteDatosUsuario(usuario_SucursalList: sucursal_usuarioJoin[]) {
    let self = this; // this is unused
    var usu: usuario = new usuario();
    usu.rut_usuario = Number(this.validadores._desenmascaraRutyQuitaDV(this.formulario.controls["rut_usuario"].value));
    usu.login = this.formulario.controls["login"].value;
    this.client.query({
        query: gql`
        query($entidad: usuarioInputType){
          usuario{
            existe(entidad:$entidad){
              respuesta
            }
          }
        }
        `,
        fetchPolicy: 'network-only',
        variables: {
          "entidad": usu
        },
      },
      function (respuesta) {

        if (respuesta.data.usuario.existe.respuesta) {
          var res = window.confirm("El Usuario ingresado ya existe. ¿Desea sobreescribirlo?");
          if (res) {
            self.actualizar(usuario_SucursalList);
          }
        }
        else {
          self.insertar(usuario_SucursalList);
        }
      }
    );
  }

  actualizar(usuario_SucursalList: sucursal_usuarioJoin[]) {
    this.selectedUsuario.rut_usuario = Number(this.validadores._desenmascaraRutyQuitaDV(this.formulario.controls["rut_usuario"].value));
    this.selectedUsuario.login = this.formulario.controls["login"].value;
    this.selectedUsuario.password = this.formulario.controls["password"].value;
    this.selectedUsuario.mail = this.formulario.controls["mail"].value;
    this.selectedUsuario.activo = this.formulario.controls["activo"].value;
    this.selectedUsuario.nombre_completo = this.formulario.controls["nombre_completo"].value;
    this.selectedUsuario.flag_cambioclave = this.formulario.controls["flag_cambioclave"].value;
    this.selectedUsuario.max_conexiones_concurrentes = 1;
    this.refrescar(this.selectedUsuario);
    this.actualizarRol();
    this.refrescarSucursal(usuario_SucursalList);
    this.onSuccess.emit();
  }

  actualizarRol(){
    this.selectedUsuarioRol.rut_usuario = Number(this.validadores._desenmascaraRutyQuitaDV(this.formulario.controls["rut_usuario"].value));
    let valor =  this.formulario.controls["rol"].value;
    if(valor[0]==undefined){
      this.selectedUsuarioRol.roles_codigo = this.formulario.controls["rol"].value;
    }else{
      this.selectedUsuarioRol.roles_codigo = valor[0];
    }
    this.refrescarRol(this.selectedUsuarioRol);

  }

  refrescar(usuario: usuario) {
    let self = this;
    var bodyx = usuario;
    delete usuario["__typename"];
    if (usuario.password == undefined) {
      usuario.password = "";
    }
    this.client.mutate({
      mutation: gql`
      mutation($entidad: usuarioInputType)
      {
        usuario
        {
          modificar(entidad: $entidad) {
            respuesta{
              rut_usuario
              login
              password
              fecha_creacion
              fecha_modificacion
              mail
              activo
              nombre_completo
              flag_cambioclave
            }
          }
        }
      }
      `,
      variables: {
        'entidad': bodyx,
      }
    },
      function (respuesta) {
        if (respuesta.data.usuario.modificar.respuesta != undefined) {
          setTimeout(() => self.obtenerDatosUsuario(), 1000);
        }
      });
  }

  obtenerDatosUsuario() {
    let self = this;
    self.rut_empresa = self.accesolocalstorage.getRutEmpresa();
    self.client.query({
      query: gql`
      query($rut_empresa:Decimal){
        usuario{
          obtenerTodosUsuarioxEmpresa(rut_empresa:$rut_empresa){
            respuesta{
              registros{
                rut_usuario
                login
                fecha_creacion
                fecha_modificacion
                mail
                activo
                nombre_completo
                flag_cambioclave
              }
            }
          }
        }
      }
      `,
      variables: {
        'rut_empresa': self.rut_empresa,
      },
      fetchPolicy: 'no-cache',
    },
      function (respuesta) {
        self.usuarioList = respuesta.data.usuario.obtenerTodosUsuarioxEmpresa.respuesta.registros;
      });
  }

  refrescarRol(usuario_rol: usuario_rol) {
    let self = this;
    var bodyx = usuario_rol;
    delete usuario_rol["__typename"];
    this.client.mutate({
      mutation: gql`
      mutation($entidad : usuario_rolInputType){
        usuario_rol{
          guardar(entidad:$entidad){
            respuesta{
              rut_usuario
              roles_codigo
              fecha_asignacion
            }
          }
        }
      }
      `,
      variables: {
        'entidad': bodyx,
      }
    },
    function (respuesta) {
      if (respuesta.data.usuario_rol.guardar.respuesta != undefined) {
        setTimeout(() => self.obtenerDatosUsuario(), 1000);
      }
    });
  }

  refrescarSucursal(usuario_SucursalList: sucursal_usuarioJoin[]) {
    let rut_empresa = this.accesolocalstorage.getRutEmpresa();
    let rut_usuario = Number(this.validadores._desenmascaraRutyQuitaDV(this.formulario.controls["rut_usuario"].value));
    for (var i = 0; i < usuario_SucursalList.length; i++) {
      delete usuario_SucursalList[i]["__typename"];
      delete usuario_SucursalList[i].nombre;
      usuario_SucursalList[i].rut_empresa = rut_empresa
     }
     //console.log(usuario_SucursalList);
     let self = this;
     var bodyx =  usuario_SucursalList;
     this.client.mutate({
      mutation: gql`
      mutation($entidad:sucursal_usuarioListInputType, $rut_empresa:Decimal, $rut_usuario:Decimal){
        sucursal_usuario{
          guardarSucursalUsuario(entidad:$entidad, rut_empresa:$rut_empresa, rut_usuario:$rut_usuario){
            respuesta{
              rut_empresa
              fecha_asignacion
              rut_usuario
              sucursal_codigo
            }
          }
        }
      }
      `,
      variables: {
        "entidad": {
          "objet":bodyx
        },
        "rut_empresa":rut_empresa,
        "rut_usuario": rut_usuario
      }
    },
    function (mensajes) {
      if (mensajes.data.sucursal_usuario.guardarSucursalUsuario.mensajes != undefined) {
        setTimeout(() => self.obtenerUsuarioSucursal(rut_empresa), 1000);
      }
    });

  }

  obtenerUsuarioSucursal(rut_usuario:number){
    let self = this;
    self.rut_empresa = self.accesolocalstorage.getRutEmpresa();
    self.client.query({
      query: gql`
      query($rut_empresa:Decimal, $rut_usuario:Decimal){
        usuario{
          obtenerUsuarioxSucursal(rut_empresa:$rut_empresa, rut_usuario:$rut_usuario){
            respuesta{
              registros{
                rut_empresa
                sucursal_codigo
                nombre
                fecha_asignacion
                rut_usuario
              }
            }
          }
        }
      }
      `,
      variables: {
        'rut_empresa': self.rut_empresa,
        'rut_usuario': rut_usuario
      },
      fetchPolicy: "no-cache",
    },
      function (respuesta) {
        self.usuarioSucursalList = respuesta.data.usuario.obtenerUsuarioxSucursal.respuesta.registros;
      });
  }

  insertar(usuario_SucursalList: sucursal_usuarioJoin[]) {
    this.selectedUsuario.rut_usuario = Number(this.validadores._desenmascaraRutyQuitaDV(this.formulario.controls["rut_usuario"].value));
    this.selectedUsuario.login = this.formulario.controls["login"].value;
    this.selectedUsuario.password = this.formulario.controls["password"].value;
    this.selectedUsuario.mail = this.formulario.controls["mail"].value;
    this.selectedUsuario.activo = this.formulario.controls["activo"].value;
    this.selectedUsuario.nombre_completo = this.formulario.controls["nombre_completo"].value;
    this.selectedUsuario.max_conexiones_concurrentes = 1;
    this.selectedUsuario.flag_cambioclave = true;
    this.postUsuario(this.selectedUsuario);
    this.actualizarRol();
    this.refrescarSucursal(usuario_SucursalList);
    this.limpiarFormulario();
    this.onSuccess.emit();
  }

  postUsuario(usuario: usuario) {
    let self = this;
    var bodyx = usuario;
    this.client.mutate({
      mutation: gql`
      mutation($entidad: usuarioInputType)
      {
        usuario
        {
          agregar(entidad: $entidad) {
            respuesta{
              rut_usuario
              login
              password
              fecha_creacion
              fecha_modificacion
              mail
              activo
              nombre_completo
              flag_cambioclave
            }
          }
        }
      }
      `,
      variables: {
        'entidad': bodyx,
      }
    },
      function (respuesta) {
        if (respuesta.data.usuario.agregar.respuesta != undefined) {
          setTimeout(() => self.obtenerDatosUsuario(), 1000);
          self.onSave.emit();
        }
      });
  }

  limpiarFormulario(){
    this.formulario.reset();
    this.formulario.get('rol').setValue(15);
    this.formulario.get('activo').setValue(true);
    this.usuarioSucursalList = [];
    this.agregarModal.hide();
  }


}
